import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-5 text-xl font-medium opp-header" }
const _hoisted_4 = { class: "pb-5 gap-x-4 md:gap-x-5 md:gap-y-1 gap-y-3 opp-container" }

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetOpportunitiesNearMeRequest, GetOpportunitiesNearMeResponse,
} from "@/dtos";

import OpportunityCard from "./OpportunityCard.vue";
import OpportunityCardMinimal from "./OpportunityCardMinimal.vue";
import OpportunityCardStacked from "./OpportunityCardStacked.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpportunitiesNearMeWidget',
  props: {
    numOfPosts: {
        type: Number,
        default: 6
    },
    use: {
        type: String,
        default: "card"
    },
},
  setup(__props) {

// @ts-ignore
const props = __props

const use = ref(props.use);
const opportunitiesNearMeResponse: Ref<GetOpportunitiesNearMeResponse> = ref({});
const location = ref('');
const ip = ref("");

const opportunities = computed( () => {
    return opportunitiesNearMeResponse.value.results;
});

onMounted(async () => {
    let urlParams = new URLSearchParams(window.location.search);
    ip.value = urlParams.get("ip") ?? "";
    await getOpportunitiesNearMeForWidget();
});

const getOpportunitiesNearMeForWidget = async () => {
    await client.get<GetOpportunitiesNearMeResponse>(new GetOpportunitiesNearMeRequest({
        pageSize: props.numOfPosts,
        ip: ip.value
    }))
        .then(response => {
            location.value = response.locationFormattedAddress;
            opportunitiesNearMeResponse.value = response;
        });
}

return (_ctx: any,_cache: any) => {
  return (!opportunitiesNearMeResponse.value.results)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading opportunities... "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "heading", { location: location.value }, () => [
          _createElementVNode("p", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("Opportunities near ")),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("em", null, _toDisplayString(location.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunities.value, (opportunity) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "opp-near-card",
              key: opportunity.id
            }, [
              _renderSlot(_ctx.$slots, "opportunity", _mergeProps({ ref_for: true }, opportunity), () => [
                (use.value === 'minimal')
                  ? (_openBlock(), _createBlock(OpportunityCardMinimal, {
                      key: 0,
                      opportunity: opportunity
                    }, null, 8, ["opportunity"]))
                  : (use.value === 'stacked')
                    ? (_openBlock(), _createBlock(OpportunityCardStacked, {
                        key: 1,
                        opportunity: opportunity
                      }, null, 8, ["opportunity"]))
                    : (_openBlock(), _createBlock(OpportunityCard, {
                        key: 2,
                        opportunity: opportunity
                      }, null, 8, ["opportunity"]))
              ])
            ]))
          }), 128))
        ])
      ]))
}
}

})